import React from 'react';
import classnames from 'classnames';
import UserLink from '../../../../../../User/Link';
import { useTranslation } from 'react-i18next';
import s from './Attribution.scss';
export var MobileAttribution = function (_a) {
    var author = _a.author, showAuthorTooltip = _a.showAuthorTooltip, className = _a.className, userlinkClassName = _a.userlinkClassName;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['attribution'], s['attributionv2'], className) }, author && (React.createElement("span", null,
        t('deviationview.overlay.by'),
        ' ',
        React.createElement(UserLink, { className: classnames(s['user-link'], s['user-linkv2'], userlinkClassName), user: author, withTooltip: showAuthorTooltip, biData: {
                creatorid: author.useridUuid,
            } })))));
};
MobileAttribution.displayName = 'MobileAttribution';
export default MobileAttribution;
//# sourceMappingURL=MobileAttribution.js.map